/* The delivery-route switch.
 *
 * Eilat is a free-trade zone, so the same product has two legitimate prices
 * depending on whether the customer collects it in person or has it shipped.
 * This keeps every switch on the page in agreement, remembers the choice, and
 * tells assistive technology that the prices on screen have changed meaning.
 *
 * What it does NOT do, ever: compute tax. It moves which of two server-rendered
 * figures is presented first. The tax charged is resolved by Shopify at
 * checkout from the delivery destination, and a number invented here would
 * drift from that.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jm-route';
  var VALID = { pickup: true, ship: true };

  function current() {
    var r = document.documentElement.getAttribute('data-jm-active-route');
    return VALID[r] ? r : 'pickup';
  }

  function remember(route) {
    try {
      window.localStorage.setItem(STORAGE_KEY, route);
    } catch (e) {
      /* Storage can be unavailable or full. The route still applies to this
         page view; only its persistence is lost, which is not worth failing
         the interaction over. */
    }
  }

  /* The price does not move on screen, so a sighted customer sees the change
     and a screen-reader user would not. This says it out loud. */
  function announce(route) {
    var region = document.getElementById('jm-route-status');
    if (!region) return;
    var pressed = document.querySelector(
      '[data-jm-route-option="' + route + '"] .jm-route__sub'
    );
    var label = document.querySelector(
      '[data-jm-route-option="' + route + '"] .jm-route__label'
    );
    if (!label) return;
    region.textContent =
      label.textContent.trim() + (pressed ? ' — ' + pressed.textContent.trim() : '');
  }

  function paint(route) {
    document.documentElement.setAttribute('data-jm-active-route', route);
    var options = document.querySelectorAll('[data-jm-route-option]');
    for (var i = 0; i < options.length; i++) {
      var el = options[i];
      el.setAttribute(
        'aria-pressed',
        el.getAttribute('data-jm-route-option') === route ? 'true' : 'false'
      );
    }
  }

  function select(route, persist) {
    if (!VALID[route]) return;
    paint(route);
    if (persist) remember(route);
    announce(route);
    document.dispatchEvent(
      new CustomEvent('jm:route-change', { detail: { route: route } })
    );
  }

  function init() {
    /* The boot snippet already set the attribute before paint; this only brings
       the buttons into agreement with it. */
    paint(current());

    if (!document.getElementById('jm-route-status')) {
      var region = document.createElement('div');
      region.id = 'jm-route-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.className = 'visually-hidden sr-only';
      region.style.cssText =
        'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(region);
    }

    /* Delegated, because switches arrive with sections rendered after load —
       the cart drawer and quick-view both mount their own. */
    document.addEventListener('click', function (event) {
      var option = event.target.closest
        ? event.target.closest('[data-jm-route-option]')
        : null;
      if (!option) return;
      event.preventDefault();
      select(option.getAttribute('data-jm-route-option'), true);
    });

    /* הכפתור השני בעמוד המוצר: המסלול שלא נבחר.
     *
     * הוא אינו זרימת רכישה נפרדת — הוא מחליף את המסלול ואז מפעיל את
     * אותו כפתור הוספה לסל בדיוק. כך הבחירה והפעולה הן מהלך אחד
     * במקום שניים, והלוגיקה של העגלה נשארת במקום אחד.
     *
     * ההפעלה נדחית לפריים הבא כדי שהמחירים והתוויות יספיקו להתעדכן
     * לפני שהטופס נשלח — אחרת הלקוח רואה לרגע את הסכום של המסלול
     * הקודם. */
    document.addEventListener('click', function (event) {
      var swap = event.target && event.target.closest
        ? event.target.closest('[data-jm-cta-switch]')
        : null;
      if (!swap) return;
      event.preventDefault();
      /* היעד הוא תמיד המסלול השני, ולא ערך קבוע: הכפתור מציג את המסלול
       * שלא נבחר, ולכן אחרי לחיצה אחת הוא צריך להצביע לכיוון ההפוך. */
      var current = document.documentElement.getAttribute('data-jm-active-route');
      select(current === 'pickup' ? 'ship' : 'pickup', true);
      var primary = document.getElementById('AddToCart');
      if (!primary) return;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          primary.click();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* The cart drawer renders itself in JavaScript from /cart.js, which carries no
 * metafields — so the exempt total cannot be known in the browser. Rather than
 * let the drawer show a lone unlabelled figure, the server-rendered fragment is
 * pulled in after every cart change and injected beneath it. */
(function () {
  'use strict';

  var HOST_ID = 'jm-cart-vat-host';
  var pending = false;

  function refresh() {
    if (pending) return;
    pending = true;
    var root = document.getElementById('cart-info');
    if (!root) {
      pending = false;
      return;
    }
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root.replace(/\/$/, '')
      : '') + '/cart?view=jm-vat', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        var host = document.getElementById(HOST_ID);
        if (!host) {
          host = document.createElement('div');
          host.id = HOST_ID;
          root.parentNode.insertBefore(host, root.nextSibling);
        }
        host.innerHTML = html;
        /* The injected fragment carries its own switch, which must agree with
         * the route already chosen elsewhere on the page. */
        var route = document.documentElement.getAttribute('data-jm-active-route');
        var options = host.querySelectorAll('[data-jm-route-option]');
        for (var i = 0; i < options.length; i++) {
          options[i].setAttribute(
            'aria-pressed',
            options[i].getAttribute('data-jm-route-option') === route ? 'true' : 'false'
          );
        }
      })
      .catch(function () {
        /* A failed refresh leaves the previous server-rendered totals in place,
           which is stale but never wrong about which route it is describing. */
      })
      .then(function () {
        pending = false;
      });
  }

  function watch() {
    var root = document.getElementById('cart-info');
    if (!root || !window.MutationObserver) return;
    /* The fragment renders only with the dual-price setting on (snippets/jm-cart-vat.liquid).
       With it off, as on the live store, this fetched an empty /cart?view=jm-vat two or three
       times on every page view. layout/theme.liquid marks <html> when the setting is on. */
    if (!document.documentElement.hasAttribute('data-jm-vat-dual')) return;
    /* Watching the drawer's own container rather than hooking the vendor's
       jQuery keeps this working regardless of which code path changed the cart. */
    new MutationObserver(function () {
      refresh();
    }).observe(root, { childList: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
